import { RuleObject } from 'antd/es/form'
import { useCallback } from 'react'
import { getJSON } from 'common/services/api'
import { CARERS_CLOCKED_IN_URL } from './queryConstants'
import { getQueryParams } from 'utils/getQueryParams'

export const useCarersClockedInValidator = (instanceId: string) => {
  const validateTeamMembers = useCallback(async (_: RuleObject, value: string[]) => {
    if (!instanceId) {
      return Promise.resolve()
    }

    const params = getQueryParams({
      teamMembers: value,
    })

    try {
      const response = await getJSON({
        url: `${CARERS_CLOCKED_IN_URL}/${instanceId}?${params}`,
        isRota: true,
      })

      if (response) {
        return Promise.reject(
          new Error('Some team members are already clocked in')
        )
      }

      return Promise.resolve()
    } catch (error) {
      return Promise.resolve()
    }
  }, [instanceId])

  return { validator: validateTeamMembers }
} 